<script>
import CustomReportPage1 from './create-custom-report-pages/CustomReportPage1.vue';
import CustomReportPage2 from './create-custom-report-pages/CustomReportPage2.vue';
import CustomReportPage3 from './create-custom-report-pages/CustomReportPage3.vue';
import CustomReportPage4 from './create-custom-report-pages/CustomReportPage4.vue';
import CustomReportPage5 from './create-custom-report-pages/CustomReportPage5.vue';
import CustomReportPage6 from './create-custom-report-pages/CustomReportPage6.vue';
import CustomReportPage7 from './create-custom-report-pages/CustomReportPage7.vue';
import CustomReportPage8 from './create-custom-report-pages/CustomReportPage8.vue';
import CustomReportPage9 from './create-custom-report-pages/CustomReportPage9.vue';
import CustomReportPage10 from './create-custom-report-pages/CustomReportPage10.vue';
import { db } from '../firebase';
import axios from 'axios';


export default {
    props: ['newReportName', 'viewingReport', 'reportId'],
    components: {
        CustomReportPage1,
        CustomReportPage2,
        CustomReportPage3,
        CustomReportPage4,
        CustomReportPage5,
        CustomReportPage6,
        CustomReportPage7,
        CustomReportPage8,
        CustomReportPage9,
        CustomReportPage10
    },
    data() {
        return {
            currentPageIndex: 0, // to track the page index
            currentPage: 0,
            transitionDirection: 'right',
            activePagePath: [0], // push page IDs to this to manage the branching paths
            currentRenderedComponent: 1,

            faultStatusValues: [
                { value: '', label: '', hex: '#439446' },
                { value: 'active', label: 'Fault', hex: '#f31b2b' },
                { value: 'in_progress', label: 'In Progress', hex: '#ffbf00' },
                { value: 'rectified', label: 'Rectified', hex: '#1f5ea4' },
            ],

            originalStatuses: null

            // NOTE - breakdown of which component is which: 
            // CustomReportPage1 - Landing page (select site(s), report type)
            // CustomReportPage2 - filter pages for report type - asset type
            // CustomReportPage3 - report fields for assets/locations i.e. name, install date etc
            // CustomReportPage4 - report fields for last maintained/attended
            // CustomReportPage5 - report fields for attendance log
            // CustomReportPage6 - report fields for management activity log
            // CustomReportPage7 - report fields for site activity log
            // CustomReportPage8 - scheduling page (final step)

            // CustomReportPage9 - report fields for faults
        }
    },
    mounted() {
        // console.log(this.$store.state.createCustomReport)
    },
    watch: {
    },
    methods: {
        transitionPage(index) {
            // Set transition direction
            if (index > 0) {
                this.transitionDirection = 'right';
            } else if (index < 0) {
                this.transitionDirection = 'left';
            }

            const nextIndex = this.currentPageIndex + index;

            // Guard to prevent out-of-bounds access
            if (nextIndex < 0 || nextIndex >= this.activePagePath.length) {
                // can run things once report is finished here
                return;
            }

            // Update page index and currentPage
            this.currentPageIndex = nextIndex;
            this.currentPage = nextIndex;

            // Update the currentRenderedComponent based on activePagePath
            this.currentRenderedComponent = this.activePagePath[this.currentPageIndex] || 1; // if doesn't exists or 0, reset to 1 for first page

            // console.log("currentPage:", this.currentPage, "currentPageIndex:", this.currentPageIndex, "currentRenderedComponent:", this.currentRenderedComponent);
        },

        // initialize the active page path
        setupPaths() {
            const reportType = this.$store.getters['createCustomReport/getReportType'];
            this.activePagePath = [0] // make sure it's always 0 to start on the first page

            switch (reportType) { // asset type
                case 0:
                    this.activePagePath = [...this.activePagePath, 2, 3, 8];
                    break;

                case 1: // last maintained / attended
                    this.activePagePath = [...this.activePagePath, 4, 8];
                    break;

                case 2: // attendance log
                    this.activePagePath = [...this.activePagePath, 5, 8];
                    break;

                case 3: // management log
                    this.activePagePath = [...this.activePagePath, 6, 8];
                    break;

                case 4: // site activity log
                    this.activePagePath = [...this.activePagePath, 7, 8];
                    break;

                case 5: // faults
                    this.activePagePath = [...this.activePagePath, 9, 8];
                    break;

                case 6: // faults log
                    this.activePagePath = [...this.activePagePath, 10, 8];
                    break;

                default:
                    break;
            }

            // Reset the initial page and set the first rendered component
            this.currentPage = 0;
            this.currentPageIndex = 0;
            this.currentRenderedComponent = this.activePagePath[this.currentPageIndex];
        },

        formatStatuses(statuses, sender) { // sets object filters into correct format for api
            sender.forEach((status, index) => {
                status = { asset_page_label: status };
                statuses[index] = status
            })
        },

        formatFilters() { // used to ensure statuses are in correct format for API
            const getters = this.$store.getters

            let postFilters = getters['createCustomReport/getSelectedFilterOptions'];

            // Store original values for resetting later
            this.originalStatuses = {
                lifecycle_status: getters['createCustomReport/getSelectedFilterOptions'].lifecycle_status ? [...getters['createCustomReport/getSelectedFilterOptions'].lifecycle_status] : null,
                maintenance_status: getters['createCustomReport/getSelectedFilterOptions'].maintenance_status ? [...getters['createCustomReport/getSelectedFilterOptions'].maintenance_status] : null,
                warranty_status: getters['createCustomReport/getSelectedFilterOptions'].warranty_status ? [...getters['createCustomReport/getSelectedFilterOptions'].warranty_status] : null,
                fault_status: getters['createCustomReport/getSelectedFilterOptions'].fault_status ? [...getters['createCustomReport/getSelectedFilterOptions'].fault_status] : null
            };

            if (getters['createCustomReport/getSelectedFilterOptions'].lifecycle_status) {
                this.formatStatuses(postFilters.lifecycle_status, getters['createCustomReport/getSelectedFilterOptions'].lifecycle_status);
            }
            if (getters['createCustomReport/getSelectedFilterOptions'].maintenance_status) {
                this.formatStatuses(postFilters.maintenance_status, getters['createCustomReport/getSelectedFilterOptions'].maintenance_status);
            }
            if (getters['createCustomReport/getSelectedFilterOptions'].warranty_status) {
                this.formatStatuses(postFilters.warranty_status, getters['createCustomReport/getSelectedFilterOptions'].warranty_status);
            }

            let faultStatuses = []
            if (postFilters.fault_status && postFilters.fault_status.length) {
                postFilters.fault_status.forEach(fault => {
                    faultStatuses.push(this.faultStatusValues.find(data => data.label === fault).value) // only value is required for filtering
                });

                postFilters.fault_status = faultStatuses
            }

            this.$store.dispatch('createCustomReport/selectFilterOptions', postFilters)
        },

        resetFaultStatuses() { // reset fault statuses back to original format after API calls
            const getters = this.$store.getters
            let postFilters = getters['createCustomReport/getSelectedFilterOptions'];

            if (postFilters.fault_status && postFilters.fault_status.length) {
                let originalFaultStatuses = []
                postFilters.fault_status.forEach(faultValue => {
                    const faultData = this.faultStatusValues.find(data => data.value === faultValue)
                    if (faultData) {
                        originalFaultStatuses.push(faultData.label)
                    }
                });
                postFilters.fault_status = originalFaultStatuses
                this.$store.dispatch('createCustomReport/selectFilterOptions', postFilters)
            }
        },

        resetAllStatuses() { // reset all statuses back to original format after API calls
            const getters = this.$store.getters
            let postFilters = getters['createCustomReport/getSelectedFilterOptions'];

            // Reset statuses that were processed by formatStatuses
            if (this.originalStatuses) {
                if (this.originalStatuses.lifecycle_status) {
                    postFilters.lifecycle_status = this.originalStatuses.lifecycle_status;
                }
                if (this.originalStatuses.maintenance_status) {
                    postFilters.maintenance_status = this.originalStatuses.maintenance_status;
                }
                if (this.originalStatuses.warranty_status) {
                    postFilters.warranty_status = this.originalStatuses.warranty_status;
                }
                if (this.originalStatuses.fault_status) {
                    postFilters.fault_status = this.originalStatuses.fault_status;
                }
                
                this.$store.dispatch('createCustomReport/selectFilterOptions', postFilters)
            }
        },

        // create new report and save
        async saveReport() {

            const getters = this.$store.getters
            const assetTypes = (getters['createCustomReport/getAssetTypes'].length) ? getters['createCustomReport/getAssetTypes'].map(x => x.asset_type) : []

            this.formatFilters()

            const reportData = {

                // report data from store
                createdBy: getters.user.data.email,
                name: this.newReportName,
                client_id: this.$route.params.client_id,
                sites: getters['createCustomReport/getSites'].map(x => x.site_id),
                reportType: getters['createCustomReport/getReportType'],
                reportDetails: getters['createCustomReport/getSelectedReportDetails'],
                assetTypes: assetTypes, // only used in API if reportType == 0
                assetFilterOptions: getters['createCustomReport/getSelectedFilterOptions'], // formatFilters function required for this to be in correct format

                schedulingMeta: getters['createCustomReport/getSchedulingDetails'],

                //other report type data
                maintenanceAssetType: getters['createCustomReport/getMaintenanceSelectedAssetType'],
                selectedRange: getters['createCustomReport/getSelectedRange'],
                customRangeValue: getters['createCustomReport/getCustomRange'].value,
                customRangeInterval: (getters['createCustomReport/getCustomRange'].value) ? getters['createCustomReport/getCustomRange'].interval : 'null',
                fault_data: getters['createCustomReport/getFaultTypes']
            }

            try {
                if (this.viewingReport && this.reportId) {
                    // Update existing report
                    await axios({
                        method: 'put',
                        url: process.env.VUE_APP_API_URL + '/update-report',
                        headers: {
                            'Authorization': `Bearer ${getters.user.auth.accessToken}`
                        },
                        data: {
                            reportId: this.reportId,
                            reportData: reportData
                        }
                    }).then((response) => {
                        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Custom Report Updated', life: 5000 });

                        if (!response.data.isRecurring) {
                            // this.$toast.add({ severity: 'info', summary: 'Info', detail: 'Sending Report, please do not close this window.', life: 5000 });
                            axios({
                                method: 'post',
                                url: process.env.VUE_APP_API_URL + '/send-report',
                                headers: {
                                    'Authorization': `Bearer ${getters.user.auth.accessToken}`
                                },
                                data: {
                                    reportId: this.reportId
                                }
                            }).then(() => {
                                this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Custom Report Sent', life: 5000 });
                            }).catch(error => {
                                console.error(error)
                            })
                        }

                        // Log the update
                        db.collection('logs').add({
                            activity: 'Report Updated: ' + this.newReportName,
                            timestamp: new Date(),
                            user: getters.user.data.email,
                            client_id: getters.user.data.client.key
                        });
                    }).catch(error => {
                        console.error(error)
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: 'There was an issue updating the report, please try again.', life: 5000 });
                    }).finally(() => {
                        this.resetAllStatuses(); // Reset all statuses back to original format
                    });
                } else {
                    // Create new report
                    reportData.createdAt = new Date();
                    reportData.lastSent = null;

                    await axios({
                        method: 'post',
                        url: process.env.VUE_APP_API_URL + '/create-report',
                        headers: {
                            'Authorization': `Bearer ${getters.user.auth.accessToken}`
                        },
                        data: {
                            reportData: reportData
                        }
                    }).then((response) => {
                        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Custom Report Created', life: 5000 });

                        if (!response.data.isRecurring) {
                            // this.$toast.add({ severity: 'info', summary: 'Info', detail: 'Sending Report, please do not close this window.', life: 5000 });
                            const reportId = response.data.documentId;
                            axios({
                                method: 'post',
                                url: process.env.VUE_APP_API_URL + '/send-report',
                                headers: {
                                    'Authorization': `Bearer ${getters.user.auth.accessToken}`
                                },
                                data: {
                                    reportId: reportId
                                }
                            }).then(() => {
                                this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Custom Report Sent', life: 5000 });
                            }).catch(error => {
                                console.error(error)
                            })
                        }

                        // Log the update
                        db.collection('logs').add({
                            activity: 'Report Created: ' + this.newReportName,
                            timestamp: new Date(),
                            user: getters.user.data.email,
                            client_id: getters.user.data.client.key
                        });
                    }).catch(error => {
                        console.error(error)
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: 'There was an issue creating a new report, please try again.', life: 5000 });
                    }).finally(() => {
                        this.resetAllStatuses(); // Reset all statuses back to original format
                    });
                }

                await this.$emit('create-report')
                await this.$emit('close-modal')
            } catch (error) {
                console.error(error)
                this.$toast.add({ severity: 'error', summary: 'Error', detail: 'There was an issue saving the report, please try again.', life: 5000 });
                this.resetAllStatuses(); // Reset all statuses on error
            }
        },

        sendTestReport(email) {
            // add any other logic here
            console.log('sendTestReport from modal', email)

            const getters = this.$store.getters
            const assetTypes = (getters['createCustomReport/getAssetTypes'].length) ? getters['createCustomReport/getAssetTypes'].map(x => x.asset_type) : []

            this.formatFilters()

            const reportData = {

                // report data from store
                createdBy: getters.user.data.email,
                name: this.newReportName,
                client_id: this.$route.params.client_id,
                sites: getters['createCustomReport/getSites'].map(x => x.site_id),
                reportType: getters['createCustomReport/getReportType'],
                reportDetails: getters['createCustomReport/getSelectedReportDetails'],
                assetTypes: assetTypes, // only used in API if reportType == 0
                assetFilterOptions: getters['createCustomReport/getSelectedFilterOptions'], // formatFilters function required for this to be in correct format

                schedulingMeta: getters['createCustomReport/getSchedulingDetails'],

                //other report type data
                maintenanceAssetType: getters['createCustomReport/getMaintenanceSelectedAssetType'],
                selectedRange: getters['createCustomReport/getSelectedRange'],
                customRangeValue: getters['createCustomReport/getCustomRange'].value,
                customRangeInterval: (getters['createCustomReport/getCustomRange'].value) ? getters['createCustomReport/getCustomRange'].interval : null,
                fault_data: getters['createCustomReport/getFaultTypes']
            }

            axios({
                method: 'post',
                url: process.env.VUE_APP_API_URL + '/send-test-report',
                headers: {
                    'Authorization': `Bearer ${getters.user.auth.accessToken}`
                },
                data: {
                    reportData: reportData,
                    testEmails: email
                }
            }).then(() => {
                this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Test Report Sent', life: 5000 });
            }).catch(error => {
                console.error(error)
            }).finally(() => {
                this.resetAllStatuses(); // Reset all statuses back to original format
            })
        }
    },
    render(h) {
        return h('div', [
            h('transition', {
                attrs: { name: `page-transition-${this.transitionDirection}` },
            }, [
                h(`CustomReportPage${this.currentRenderedComponent}`, {
                    key: this.currentRenderedComponent, // Make sure each page transition is unique
                    on: {
                        'send-test-report': this.sendTestReport
                    }
                })
            ]),
            h('div', {
                class: 'p-d-flex p-jc-between button__row',
                style: { gap: '1rem', padding: '1rem' }
            }, [
                h('Button', {
                    props: { type: 'button', label: (this.currentPage === 0) ? 'Cancel' : 'Back' },
                    class: 'p-button',
                    on: {
                        click: (e) => {
                            e.preventDefault();
                            if (this.currentPage === 0) {
                                this.$emit('close-modal'); // Emit to close modal if on first page
                            } else {
                                this.transitionPage(-1); // Go to the previous page
                            }
                        }
                    }
                }),
                h('Button', {
                    props: { type: 'button', label: (this.currentRenderedComponent === 8) ? 'Save' : 'Continue' },
                    class: 'p-button-primary',
                    on: {
                        click: async (e) => {
                            e.preventDefault();

                            // console.log('current rendered: ', this.currentRenderedComponent)
                            const storedata = this.$store.state.createCustomReport

                            if (this.currentRenderedComponent === 1) {
                                if ( // flags used to prevent continuation on first page
                                    (storedata.reportType != 3 && !storedata.selectedSites.length) ||
                                    (storedata.reportType == 0 && !storedata.selectedAssetTypes.length) ||
                                    (storedata.reportType == 5 && !storedata.selectedSites.length && !storedata.selectedFaultTypes.length) ||
                                    (storedata.reportType != 0 && storedata.reportType != 5 && !storedata.selectedRange)
                                ) {
                                    this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Please ensure site(s) and Report Type specifics are selected.', life: 5000 });
                                    return
                                }

                                this.setupPaths(); // Set up future path based on reportType selected
                            }

                            const pagesWithDetailsGuard = [3, 4, 5, 6, 7, 9]
                            if (pagesWithDetailsGuard.includes(this.currentRenderedComponent)) {
                                // add guard for report detail pages
                                if (storedata.selectedReportDetails.length < 1) {
                                    this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Please select at least 1 Report Detail.', life: 5000 });
                                    return
                                }

                                // if (storedata.selectedReportDetails.length < 2) {
                                //     this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Please select at least 1 optional Report Detail.', life: 5000 });
                                //     return
                                // }
                            }

                            if (this.currentRenderedComponent === 8) {
                                // save report when continuing on last page
                                if (!storedata.schedulingDetails.sendTo || (storedata.schedulingDetails.sendTo && !storedata.schedulingDetails.sendTo.length)) {
                                    this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Please add at least 1 recipient.', life: 5000 });
                                    return
                                } else if (Number(storedata.schedulingDetails.reportInterval) < 1 && storedata.schedulingDetails.repeatReport) {
                                    this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Please select a valid report interval (every 1 day, 2 days, 3 days, etc).', life: 5000 });
                                    return
                                } else {
                                    await this.saveReport()
                                    await this.$emit('create-report')
                                    await this.$emit('close-modal')
                                    return
                                }
                            }

                            this.transitionPage(1); // Move to next page
                        }
                    }
                }),
            ])
        ]);
    }



}
</script>

<style lang="scss" scoped>
/* Transition for sliding right (Enter and Leave) */
.page-transition-right-enter-active,
.page-transition-right-leave-active {
    transition: transform 0.3s ease, opacity 0.5s ease;
    position: absolute;
    width: 100%;
}

.page-transition-right-enter {
    transform: translateX(100%);
    /* Start off-screen to the right */
    opacity: 0;
}

.page-transition-right-enter-to {
    transform: translateX(0);
    /* Slide into place */
    opacity: 1;
}

.page-transition-right-leave-to {
    transform: translateX(-100%);
    /* Slide out to the left */
    opacity: 0;
}

/* Transition for sliding left (Enter and Leave) */
.page-transition-left-enter-active,
.page-transition-left-leave-active {
    transition: transform 0.3s ease, opacity 0.5s ease;
    position: absolute;
    width: 100%;
}

.page-transition-left-enter {
    transform: translateX(-100%);
    /* Start off-screen to the left */
    opacity: 0;
}

.page-transition-left-enter-to {
    transform: translateX(0);
    /* Slide into place */
    opacity: 1;
}

.page-transition-left-leave-to {
    transform: translateX(100%);
    /* Slide out to the right */
    opacity: 0;
}

.report__page {
    // opacity: 1;
    // transition: all 0.3s ease;
}
</style>
